import { jsx } from "react/jsx-runtime";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import { validateTidalLicense } from "../../base/index.js";
function Unarchive(props) {
  return /* @__PURE__ */ jsx(
    UnarchiveIcon,
    {
      "data-testid": "Unarchive",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Unarchive",
      "data-tidal-icon-meta": "fileActions"
    }
  );
}
Unarchive.tidalIconMeta = {
  categories: "fileActions",
  name: "Unarchive"
};
validateTidalLicense();
export {
  Unarchive
};
//# sourceMappingURL=Unarchive.js.map
